import React from 'react';
import PropTypes from 'prop-types';

import { compose, withHandlers, withProps } from 'recompose';

import { StyledSelect } from './styled';

const enhance = compose(
  withProps(() => ({
    options: [
      { value: 'MONITORING', label: 'Keep an eye' },
      { value: 'NOT_REVISED', label: 'Not reviewed' },
      { value: 'FALSE_ALARM', label: 'False positive' },
      { value: 'SOLVED', label: 'Resolved' },
    ],
  })),
  withHandlers({
    handleChangeStatus:
      ({ alertUrl, changeAlertStatus, itemId }) =>
      (option) => {
        if (!option) {
          return;
        }

        changeAlertStatus({ id: itemId, option, url: alertUrl });
      },
  })
);

const StatusChanger = ({ status, options, handleChangeStatus }) => {
  return (
    <StyledSelect
      ignoreCase
      small
      matchPos="any"
      value={status}
      options={options}
      onChange={handleChangeStatus}
      clearable={false}
    />
  );
};

StatusChanger.propTypes = {
  status: PropTypes.string,
  options: PropTypes.array,
  handleChangeStatus: PropTypes.func,
};
export default enhance(StatusChanger);
